var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WhiteTable',{attrs:{"showHeader":_vm.showHeader,"compact":_vm.compact,"columns":[
        { text: '', key: 'icon', width: 20 },
        {
          text: _vm.$t('balance_table.col_date'),
          width: 120,
          key: 'created_at',
          format: 'date',
        },
        {
          text: _vm.$t('balance_table.col_time'),
          width: 120,
          key: 'created_at',
          format: 'time',
        },
        {
          text: _vm.$t('balance_table.col_category'),
          width: 200,
          renderer: function (r) { return _vm.$t('balance_table.categories.' + r.category); },
        },
        { text: _vm.$t('balance_table.col_description'), key: 'description' },
        {
          text: _vm.$t('balance_table.col_amount'),
          key: 'amount'
        },
        {
          text: _vm.$t('balance_table.col_balance'),
          key: 'balance',
          format: 'suffix',
          suffix: '$',
          width: 120,
        } ],"rows":_vm.transactions},scopedSlots:_vm._u([{key:"col-icon",fn:function(slotProps){return [_c('BaseIcon',{class:slotProps.rowItem.amount > 0 ? 'green-5-color' : 'red-4-color',attrs:{"icon":slotProps.rowItem.amount > 0 ? 'download' : 'upload',"size":"sm"}})]}},{key:"col-amount",fn:function(slotProps){return [_c('span',{class:slotProps.rowItem.amount > 0 ? 'green-5-color' : 'red-4-color'},[_vm._v("\n              "+_vm._s(slotProps.rowItem.amount.toFixed(3))+" $\n          ")])]}},{key:"col-balance",fn:function(slotProps){return [_vm._v("\n          "+_vm._s(slotProps.rowItem.balance.toFixed(3))+" $\n      ")]}},{key:"col-description",fn:function(slotProps){return [(slotProps.rowItem.category == 'sms')?_c('span',[_vm._v("\n          "+_vm._s(_vm.$t(
              "balance_table.sms_types." +
                slotProps.rowItem.metadata.sms_source_type
            ))+"\n        ")]):_vm._e(),(slotProps.rowItem.category == 'balance_topup')?_c('span',[_vm._v("\n          "+_vm._s(slotProps.rowItem.metadata.topup_card_mask)+"\n        ")]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }